import gameIds from 'a/hub/data/GameIds';

// replace "NEW_GAME" with your gameId
export const GAME_ID = gameIds.STORYBOX;
export const LEVEL_COUNT = 3;
export const MASTERY_SCORE = 4;
export const ONBOARDING_CODE = -1;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  LEVEL_LOADING: 'LEVEL_LOADING',
  STORY_CHOICE_VIEW: 'STORY_CHOICE_VIEW',
  SETTING_CHOICE: 'SETTING_CHOICE',
  CHARACTER_CHOICE: 'CHARACTER_CHOICE',
  SETTING_VIEW: 'SETTING_VIEW',
  CHARACTER_VIEW: 'CHARACTER_VIEW',
  PAYOFF_VIEW: 'PAYOFF_VIEW',
  START_VIEW: 'START_VIEW',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  STORY_CHOICE_SELECTION: 'STORY_CHOICE_SELECTION',
  START_STORY: 'START_STORY',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  INCREMENT_LEVEL_SCORE: 'INCREMENT_LEVEL_SCORE',
  MAX_LEVEL_SCORE: 'MAX_LEVEL_SCORE',
  SHUFFLED_SOLUTIONS: 'SHUFFLED_SOLUTIONS',
  ONBOARDING_OFF: 'ONBOARDING_OFF',
  ONBOARDING_ON: 'ONBOARDING_ON,',
  INCREMENT_ZAPS: 'INCREMENT_ZAPS',
  SET_ZAPS: 'SET_ZAPS',
  INCREMENT_BITES: 'INCREMENT_BITES',

  INCREMENT_STORIES_PLAYED: 'INCREMENT_STORIES_PLAYED',
  INCREMENT_HELP_INDEX: 'INCREMENT_HELP_INDEX',
  INCREMENT_ACTION_INDEX: 'INCREMENT_ACTION_INDEX',
  RESET_TRACKED_INDICES: 'RESET_TRACKED_INDICES',
  INCREMENT_WRONG_COUNT: 'INCREMENT_WRONG_COUNT',
  QUICK_FAIL_ROUND: 'QUICK_FAIL_ROUND',
};

export const SCROLLING_BG = {
  END_POSITION: -1024,
  HEIGHT: 576,
  WIDTH: 2048,
};

export const ANIMATED_CHARACTER = {
  BOUNCE: 'BOUNCE',
  STOMP: 'STOMP',
  JUMP_SPIN: 'JUMP_SPIN',
  FROM_ABOVE: 'FROM_ABOVE',
};

export const ANIMATIONS = {
  NONE: 'none',
  SKEW: 'skew',
  SHAKE: 'shake',
  BURST: 'burst',
  STARS: 'stars',
  SHRINK: 'shrink',
  SMALL_BOX_OPEN: 'smallBoxOpen',
  SMALL_BOX_CLOSE: 'smallBoxClose',
  SMALL_BOX_SHAKE: 'smallBoxShake',
  SOLUTION_BOX_OPEN: 'solutionBoxOpen',
  SOLUTION_BOX_CLOSE: 'solutionBoxClose',
  SOLUTION_BOX_CLOSE_AND_GO: 'solutionBoxCloseAndGo',
  OPEN_SETTINGS_BOX: 'openSettingsBox',
};

// STYLES
export const OVERLAY = {
  WIDTH: 1024,
  HEIGHT: 576,
};

export const SHAKING_BOX_SOUND_INTERVAL = 1200; // 1074
